import { Component, inject, computed } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BreadcrumbService } from './breadcrumb.service';
import { BreadcrumbItem } from './models/breadcrumb.model';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent {
  private breadcrumbService = inject(BreadcrumbService);

  readonly breadcrumbs = computed(() => {
    const items = this.breadcrumbService.breadcrumbs();
    if (items.length === 0) return items;

    // Hide breadcrumbs on Dashboard (last label = 'Dashboard')
    const last = items[items.length - 1];
    if (last?.label?.toLowerCase() === 'dashboard') {
      return [];
    }

    // Keep Home as the first breadcrumb step (icon-only in template)
    return items.map((item, index) => {
      if (index === items.length - 1) {
        const { url, ...itemWithoutUrl } = item;
        return itemWithoutUrl as BreadcrumbItem;
      }
      return item;
    });
  });

  isLastItem(index: number): boolean {
    return index === this.breadcrumbs().length - 1;
  }
}

